import store from '../../core/store';

export const updateOverlay = ({ fabricOverlay, viewer }) => {
  return store.dispatch({
    type: 'fabric_overlay/UPDATE_OVERLAY',
    fabricOverlay,
    viewer,
  });
};

export const updateTool = ({ tool }) => {
  return store.dispatch({
    type: 'fabric_overlay/UPDATE_TOOL',
    tool,
  });
};

export const updateColor = (color) => {
  return store.dispatch({
    type: 'fabric_overlay/UPDATE_COLOR',
    color,
  });
};

export const updateThickness = (thickness) => {
  return store.dispatch({
    type: 'fabric_overlay/UPDATE_THICKNESS',
    thickness,
  });
};

export const setActiveObject = (object) => {
  return store.dispatch({
    type: 'fabric_overlay/SET_ACTIVE_OBJECT',
    object,
  });
};

export const setToolbarOptionsPanel = (options_panel) => {
  return store.dispatch({
    type: 'fabric_overlay/SET_TOOLBAR_OPTIONS_PANEL',
    options_panel,
  });
};

export const setCursorTooltip = (text) => {
  return store.dispatch({
    type: 'fabric_overlay/SET_CURSOR_TOOLTIP',
    text,
  });
};
